// Kanban Storage API - Interface to backend Kanban endpoints
class KanbanStorageAPI {
  private baseUrl = '/api/kanban';

  async loadBacklogData() {
    try {
      const response = await fetch(`${this.baseUrl}/data`);
      const data = await response.json();
      if (data.success) {
        return data.items || [];
      } else {
        console.error('Failed to load Kanban data:', data.message);
        return [];
      }
    } catch (error) {
      console.error('Error loading Kanban data:', error);
      return [];
    }
  }

  async loadColumns() {
    try {
      const response = await fetch(`${this.baseUrl}/columns`);
      const data = await response.json();
      if (data.success) {
        return data.data || [];
      } else {
        console.error('Failed to load Kanban columns:', data.message);
        return [];
      }
    } catch (error) {
      console.error('Error loading Kanban columns:', error);
      return [];
    }
  }

  async loadSchema() {
    try {
      const response = await fetch(`${this.baseUrl}/schema`);
      const data = await response.json();
      if (data.success) {
        return data.data;
      } else {
        console.error('Failed to load Kanban schema:', data.message);
        return null;
      }
    } catch (error) {
      console.error('Error loading Kanban schema:', error);
      return null;
    }
  }

  async saveBacklogData(items: any[]) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${this.baseUrl}/items`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        },
        body: JSON.stringify({ items })
      });
      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error('Error saving Kanban items:', error);
      return false;
    }
  }

  async saveColumns(columns: any[]) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${this.baseUrl}/columns`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        },
        body: JSON.stringify({ columns })
      });
      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error('Error saving Kanban columns:', error);
      return false;
    }
  }

  async loadEpics() {
    try {
      const response = await fetch(`${this.baseUrl}/epics`);
      const data = await response.json();
      if (data.success) {
        return data.data || [];
      } else {
        console.error('Failed to load Kanban epics:', data.message);
        return [];
      }
    } catch (error) {
      console.error('Error loading Kanban epics:', error);
      return [];
    }
  }

  async linkItemToEpic(itemId: string, epicId: string) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${this.baseUrl}/link-epic`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        },
        body: JSON.stringify({ itemId, epicId })
      });
      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error('Error linking item to epic:', error);
      return false;
    }
  }

  async unlinkItemFromEpic(itemId: string) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${this.baseUrl}/unlink-epic`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        },
        body: JSON.stringify({ itemId })
      });
      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error('Error unlinking item from epic:', error);
      return false;
    }
  }

  // Migration method for localStorage fallback
  async migrateFromLocalStorage() {
    try {
      const savedColumns = localStorage.getItem('kanban-columns');
      const savedItems = localStorage.getItem('kanban-items');
      
      if (savedColumns || savedItems) {
        console.log('📦 Migrating data from localStorage to filesystem...');
        
        if (savedColumns) {
          const columns = JSON.parse(savedColumns);
          await this.saveColumns(columns);
          console.log('✅ Columns migrated');
        }
        
        if (savedItems) {
          const items = JSON.parse(savedItems);
          await this.saveBacklogData(items);
          console.log('✅ Items migrated');
        }
        
        return true;
      }
      
      return false;
    } catch (error) {
      console.error('❌ Migration failed:', error);
      return false;
    }
  }
}

// Export default instance
const kanbanStorageAPI = new KanbanStorageAPI();
export default kanbanStorageAPI;